import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    emptyDayMessage: String,
    deletePositionConfirmation: String,
    deleteGroupConfirmation: String
  }

  connect() {
    this.initializeSortable()
    this.checkEmptyDay(this.element)
  }

  initializeSortable() {
    Sortable.create(this.element, {
      animation: 150,
      handle: ".drag-and-drop-handle",
      group: "rounds",
      onEnd: this.updatePosition.bind(this),
      emptyInsertThreshold: 200
    })
  }

  updatePosition(event) {
    const item = event.item
    const newIndex = event.newIndex
    const daySection = event.to.closest('.day-section')
    const date = daySection.dataset.date
    const oldDaySection = event.from.closest('.day-section')
    const type = item.dataset.type

    if (['picking', 'picking_and_delivery'].includes(type)) {
      this.updateGroup(item, newIndex, date, event)
    } else {
      this.updateSingle(item.dataset.id, newIndex, date, event, type)
    }
  }

  updateGroup(item, newIndex, date, event) {
    const positionIds = item.dataset.positionIds.split(',')
    const type = item.dataset.type

    Promise.all(positionIds.map(id => {
      return fetch(`/round_positions/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          position: newIndex + 1,
          delivery_date: date,
          update_group: type === 'picking'
        })
      })
    })).then(() => {
      this.checkEmptyDay(event.from)
      this.checkEmptyDay(event.to)
    })
  }

  updateSingle(positionId, newIndex, date, event, type) {
    fetch(`/round_positions/${positionId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        position: newIndex + 1,
        delivery_date: date,
        update_delivery: type === 'delivery'
      })
    }).then(() => {
      this.checkEmptyDay(event.from)
      this.checkEmptyDay(event.to)
    })
  }

  delete(event) {
    event.preventDefault()
    event.stopPropagation()
    const link = event.currentTarget
    const card = link.closest('.round_order')
    const daySection = card.closest('.day-section')

    if (confirm(this.deletePositionConfirmationValue)) {
      fetch(link.href, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/json'
        }
      }).then(response => {
        if (response.ok) {
          window.Turbo.visit(window.location.href)
        }
      })
    }
  }

  deleteGroup(event) {
    event.preventDefault()
    event.stopPropagation()
    const link = event.currentTarget
    const card = link.closest('.round_order')

    if (confirm(this.deleteGroupConfirmationValue)) {
      fetch(link.href, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/json'
        }
      }).then(response => {
        if (response.ok) {
          window.Turbo.visit(window.location.href)
        }
      })
    }
  }

  checkEmptyDay(container) {
    if (!container) return;

    const remainingCards = container.querySelectorAll('.round_order');
    const existingMessage = container.querySelector('p');

    if (remainingCards.length === 0) {
      if (!existingMessage) {
        const emptyMessage = document.createElement('p');
        emptyMessage.textContent = this.emptyDayMessageValue;
        container.appendChild(emptyMessage);
      }
    } else if (existingMessage) {
      existingMessage.remove();
    }
  }
}
